import { Fragment, useEffect, useMemo, useState } from 'react';
import { Dashboard, logo_card, noData } from '../../../components/ExportImgFigma';
import '../styles.scss';

// import "ag-grid-community/styles/ag-grid.css";
// import "ag-grid-community/styles/ag-theme-alpine.css";
import { AgGridReact } from "ag-grid-react";
import { ConfigProvider, DatePicker, Input, Pagination } from 'antd';

import { DeleteOutlined, EditOutlined, EyeOutlined, MoreOutlined, SearchOutlined, SettingOutlined } from '@ant-design/icons';
import { ColDef } from 'ag-grid-community';
import viVN from 'antd/locale/vi_VN';
import dayjs from 'dayjs';
import 'dayjs/locale/vi';
import { ListField } from '../../../api/Customer_V2/customerApi_V2';
import { ICustomerFields } from '../../../api/salesSericeCustomer/salesSericeCustomerApi';
import useDebounce from '../../../hook/useDebounce';
import useToast from '../../../hook/useToast';
import { getWidthFromHeader, renderValueAsJSX } from '../../../until';
import { ColumnKey } from '../../Customers/Tabs/CarListCardClone';
import { FlattenedField } from '../../CustomersV2/indexV2';
import StatusCellRenderer from '../../VehicleManagement/VehicleTypeManagement/Component/StatusCellRenderer';
import TabsFeilds from '../Modal/TabsFeilds';
dayjs.locale('vi');

const { RangePicker } = DatePicker;


const dataListFieldsByCustomerRecordActive = [
  {
    "id": 1,
    "title": "Hoá đơn xe",
    "fields": [
      {
        id: 1,
        fieldCode: "carLine",
        fieldLabel: "Dòng xe",
        inputType: "string",
        isActive: 1

      },
      {
        id: 2,
        fieldCode: "engineNumber",
        fieldLabel: "Số máy",
        inputType: "string",
        isActive: 1

      },
      {
        id: 3,
        fieldCode: "brand",
        fieldLabel: "Thương hiệu",
        inputType: "string",
        isActive: 1

      },
      {
        id: 4,
        fieldCode: "interiorColor",
        fieldLabel: "Màu nội thất",
        inputType: "string",
        isActive: 1

      },
      {
        id: 5,
        fieldCode: "engineType",
        fieldLabel: "Loại động cơ",
        inputType: "string",
        isActive: 1

      },
      {
        id: 6,
        fieldCode: "contractDate",
        fieldLabel: "Ngày hợp đồng",
        inputType: "date",
        isActive: 1

      },
      {
        id: 7,
        fieldCode: "contractNumber",
        fieldLabel: "Số hợp đồng",
        inputType: "string",
        isActive: 1

      },
      {
        id: 8,
        fieldCode: "paymentMethod",
        fieldLabel: "Hình thức thanh toán",
        inputType: "string",
        isActive: 1

      },
      {
        id: 9,
        fieldCode: "total",
        fieldLabel: "Tổng tiền",
        inputType: "number",
        isActive: 1

      },
      {
        id: 10,
        fieldCode: "carPrice",
        fieldLabel: "Giá xe",
        inputType: "number",
        isActive: 1

      },
      {
        id: 11,
        fieldCode: "serviceFee",
        fieldLabel: "Tiền dịch vụ",
        inputType: "number",
        isActive: 1

      }
    ]


  }
]

const dataListFieldsByCustomerRecordNotActive = [
  {
    "id": 1,
    "title": "Hoá đơn xe",
    "fields": [
    ]
  }
]


const rowData = [
  {
    "carLine": "Du lịch",
    "engineNumber": "53343401K1234",
    "brand": "KIA",
    "interiorColor": "Trắng",
    "engineType": "40G 20G AT",
    "contractDate": "21/02/2022",
    "contractNumber": "075/2025/HDMB/KIAVL-KH",
    "paymentMethod": "Trả góp",
    "total": 2500000000,
    "carPrice": 2500000000,
    "serviceFee": 0
  },
  {
    "carLine": "SUV",
    "engineNumber": "65473402M5678",
    "brand": "Mazda",
    "interiorColor": "Đen",
    "engineType": "SkyActiv 2.0",
    "contractDate": "10/03/2022",
    "contractNumber": "102/2025/HDMB/MZD-KH",
    "paymentMethod": "Trả thẳng",
    "total": 850000000,
    "carPrice": 830000000,
    "serviceFee": 20000000
  },
  {
    "carLine": "Bán tải",
    "engineNumber": "87653401F9987",
    "brand": "Ford",
    "interiorColor": "Nâu",
    "engineType": "2.2L Diesel",
    "contractDate": "05/04/2022",
    "contractNumber": "130/2025/HDMB/FRD-KH",
    "paymentMethod": "Trả góp",
    "total": 950000000,
    "carPrice": 930000000,
    "serviceFee": 20000000
  }
]

const columnDefs = [
  { headerName: "Người đại diện", field: "representative", flex: 1.5, sortable: true },
  { headerName: "Tên xe", field: "carName", flex: 2, sortable: true },
  { headerName: "Số khung (VIN)", field: "vin", flex: 2, sortable: true },
  { headerName: "Biển số xe", field: "licensePlate", flex: 1, sortable: true },
  { headerName: "Màu xe", field: "color", flex: 1 },
  { headerName: "Tổng tiền", field: "total", flex: 1, sortable: true },
  { headerName: "Số hóa đơn", field: "invoiceNumber", flex: 1, sortable: true },
  { headerName: "Ngày xuất hóa đơn", field: "invoiceDate", flex: 1.2, sortable: true },
  { headerName: "Đơn vị mua xe", field: "buyerUnit", flex: 2 },
  { headerName: "Điểm bán hàng", field: "dealer", flex: 2 }
];



const generateColumnsFromCodesAgGridReact = (
  codes: ColumnKey[],
  fields: ICustomerFields[],
  actionColumn?: ColDef<any, any>,
  onToggleStatus?: (id: number, next: boolean, rowData: any) => void, // thêm callback
): ColDef[] => {
  const baseColumns = codes
    ?.map(code => {
      const field = fields.find(f => f.fieldCode === code)
      if (!field) return null
      if (field.fieldCode === "status") {
        return {
          headerName: field.fieldLabel,
          field: field.fieldCode,
          colId: field.fieldCode,
          sortable: true,
          resizable: true,
          filter: true,
          cellRenderer: StatusCellRenderer,
          cellRendererParams: {
            onToggle: (id: number, next: boolean, rowData: any) => {
              if (onToggleStatus) {
                onToggleStatus(id, next, rowData)
              }
            },
            idKey: 'key'
          }
        }
      }

      return {
        headerName: field.fieldLabel,
        field: field.fieldCode,
        colId: field.fieldCode,
        sortable: true,
        editable: true,
        resizable: true,
        // filter: true,
        // width: getWidthFromHeader(field.fieldLabel),
        cellRenderer: (params: any) => renderValueAsJSX(params.value,field.fieldCode)
      } as ColDef
    })
    .filter(Boolean) as ColDef[]

  return actionColumn ? [actionColumn, ...baseColumns] : baseColumns
}

export default function VehicleInvoiceDetail({ stData = {} as any }) {

  const pushToast = useToast();

  const [isSettingShow, setSettingShow] = useState(false)

  const [dataFilterActive, setDataFilterActive] = useState<FlattenedField[]>([])
  const [dataFilterNoActive, setDataFilterNoActive] = useState<ListField[]>([])

  const [ColumnsMapShow, setColumnsMapShow] = useState<ColumnKey[]>([])

  const [demoList, setDemoList] = useState<any[]>([])
  const [rowHeight, setRowHeight] = useState(40)

  useEffect(() => {
    gListFieldsActive()
    gList()


    const handleResize = () => {
      const baseFactor = (48 * 100) / 1440 / 100
      const factor = window.innerWidth > 1440 ? baseFactor * 0.9 : baseFactor
      const newHeight = Math.round(window.innerWidth * factor)
      setRowHeight(newHeight)
    }
    handleResize()

    window.addEventListener('resize', handleResize)

    return (() => {
      // setPagination({ current: 1, pageSize: 20, total: 0 })
      // setSelectedRowKeys([])
      window.removeEventListener('resize', handleResize)
    })
  }, [])

  const gList = useDebounce(async (pageCurent: number = 1, pageSize: number = 10) => {

    setDemoList(rowData)
  }, 1000)


  const actionColumn: ColDef = {
    headerName: 'Hành động',
    field: 'action',
    colId: 'action',
    // width: getWidthFromHeader('Hành động'),
    cellRenderer: (params: any) => {
      // const { view, edit, delete: isDelete } = params?.data?.permissionMenu
      return (
        <div className='d-flex gap-4 justify-start align-center  h-full'>

          <EyeOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
          // onClick={() => gInfoVehicleModel(id)}
          />
          <EditOutlined
            className={`text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
          // onClick={() => gInfoVehicleModel(id, false)}
          />
          <DeleteOutlined
            className={`text-F5222D text-sm border-D9D9D9 p-5-px bg-white rounded-2 cursor-pointer `}
          // onClick={() => openModalDelete(Number(id))}
          />

        </div>

      )
    },
  }


  const gListFieldsActive = async () => {
    const flattenedFields = await dataListFieldsByCustomerRecordActive.flatMap(choice =>
      choice.fields.map(field => ({
        ...field,
        parentId: choice.id,
      }))
    );
    setDataFilterActive(flattenedFields)


    gListFieldsNotActive()
  }
  const gListFieldsNotActive = async () => {
    setDataFilterNoActive(dataListFieldsByCustomerRecordNotActive)


  }
  const onSaveDataFields = (iSsuccess?: boolean, message?: string, dataFilterActive?: FlattenedField[], dataFilterNoActive?: ListField[]) => {
    if (iSsuccess) {
      setSettingShow(false)
      pushToast(message, "success")
      setDataFilterActive(dataFilterActive ?? [])
      setDataFilterNoActive(dataFilterNoActive ?? [])
      gList()

    } else {
      pushToast(message, "warning")
    }
  }

  const onCloseDataFields = () => {
    setSettingShow(false)
  }

  const memoizedColumnDefs = useMemo(() => {
    return generateColumnsFromCodesAgGridReact(
      ColumnsMapShow, dataFilterActive, actionColumn,
      (id: number, next: boolean, rowData: any) => console.log(id, next, rowData)

    );
  }, [ColumnsMapShow]);

  useEffect(() => {
    const codes = dataFilterActive.map(f => f.fieldCode)
    setColumnsMapShow(codes)
  }, [dataFilterActive])

  return (
    <Fragment>
      {
        isSettingShow ?
          <TabsFeilds
            isSettingShow={isSettingShow}
            dataFilterActive={dataFilterActive}
            dataFilterNoActive={dataFilterNoActive}

            onSaveDataFields={onSaveDataFields}
            onClose={onCloseDataFields}
          /> :
          null
      }
      <div className="custom-page-css w-full flex flex-col items-center justify-between  pt-3">
        <div className="w-full flex items-center justify-end">

          <div className="custom-page-css absolute -top-60-px z-10 flex items-center justify-end gap-3 ">
            <div className="custom-page-css h-8 w-8 flex items-center justify-center rounded border cursor-pointer"
              onClick={() => setSettingShow(true)}
            >
              <SettingOutlined />
            </div>
            <div className="custom-page-css h-8 w-8 flex items-center justify-center rounded border cursor-pointer">
              <MoreOutlined />
            </div>

          </div>
        </div>
        <div className={` w-full`}>
          <div className="ag-theme-alpine custom-table-ag" style={{ width: '100%' }}>
            <AgGridReact<any>
              rowData={stData.chitiethoadon || []}
              columnDefs={[
                { field: "own_accu_seri", headerName: "AccSeri1" },
                { field: "own_accu_seri1", headerName: "AccuSeri2" },
                { field: "own_branch_name", headerName: "Đơn vị" },
                { field: "own_chassis_no", headerName: "Số khung" },
                { field: "own_color_name", headerName: "Màu xe" },
                { field: "own_engine_no", headerName: "Số máy" },
                { field: "own_made_year", headerName: "Năm sản xuất" },
                { field: "own_number_plate", headerName: "Biển số" },
                { field: "own_purchase_date", headerName: "Ngày mua" },
                { field: "own_route_name", headerName: "Chi nhánh" },
                { field: "own_vehicle_brand", headerName: "Hãng xe" },
                { field: "own_vehicle_model", headerName: "Mẫu xe" },
                { field: "own_vehicle_name", headerName: "Tên xe" },
                { field: "trans_commission_broker", headerName: "Hoa hồng môi giới" },
                { field: "trans_contract_date", headerName: "Ngày lập hợp đồng" },
                { field: "trans_discount_amount_sr", headerName: "Số tiền khuyến mãi" },
                { field: "trans_doc_date", headerName: "Ngày chứng từ" },
                { field: "trans_paper_amount", headerName: "Số tiền giấy" },
                { field: "trans_payment_terms_name", headerName: "Hình thức thanh toán" },
                { field: "trans_promotion_item_list", headerName: "Danh sách khuyến mãi" },
                { field: "trans_total_amount", headerName: "Tổng tiền" }
              ]}
              defaultColDef={{
                resizable: true,
                sortable: true,
              }}
              domLayout="autoHeight"
              className="my-auto-height-grid"
              rowHeight={55}
              getRowStyle={(params: any) => ({
                backgroundColor: params?.node?.rowIndex % 2 ? '#f7f9fc' : '#ffffff',
              })}
              overlayNoRowsTemplate={`
                           <div style="text-align: center; padding: 20px;">
                           <br />
                               <img src="${noData}" alt="No data" style="max-width: 150px;" />
                           <br />
                               <div>Không có dữ liệu</div>
                           <br />
                           </div>
                           `}
            />

          </div>
        </div>
      </div>
    </Fragment>
  )

}
